import React, { useState } from "react";
import DataRow from "./DataRow";
import HeadRow from "./HeadRow";
import styles from "./styles.module.css";
import { GoGraph } from "react-icons/go";
import { FiPercent } from "react-icons/fi";
import { BsFillTagFill } from "react-icons/bs";
import ModalComponent from "../../../molecules/Creator/Overview/ModalComponent";
import { SvgIcon } from "@material-ui/core";
import SVGIcon from "../../../atoms/SVGIcon";
import useSortingBy from "../../../CommonHooks/useSortingBy";

const NlpTopics = ({ list, reportInfo, editor }) => {
    console.log(list, "******************");

    const [keyword, setKeyword] = useState(list[0]);
    const [sortBy, setSortBy] = useState({ colID: null, asc: true });
    const [isDeleting, setIsDeleting] = useState(false);
    const HeadColumns = [
        { title: "Terms", isSort: false, isMain: true },
        {
            title: "Frequency",
            //  <SVGIcon style={{ color: "gray" }} src={"/New UI/SVG/graph.svg"} />
            isSort: "max_times",
            isMain: false,
        },
        {
            title: "Importance",
            // <SVGIcon style={{ color: "gray" }} src={"/New UI/SVG/percent.svg"} />
            isSort: "importance",
            isMain: false,
        },
        {
            title: "Heading",
            // <SVGIcon style={{ color: "gray" }} src={"/New UI/SVG/htags.svg"} />
            isSort: "heading_presence",
            isMain: false,
        },
    ];

    const style = editor ? { width: "100%" } : {};

    list = useSortingBy({
        items: list,
        asc: sortBy.asc,
        term: sortBy.colID == null ? "id" : HeadColumns[sortBy.colID].isSort,
    });

    return (
        <div className={styles.nlpContainer}>
            <div style={style} className={styles.tableContainer}>
                <table>
                    <thead className={styles.tableHead}>
                        <HeadRow
                            sortBy={sortBy}
                            setSortBy={setSortBy}
                            columns={HeadColumns}
                        />
                    </thead>

                    <tbody className={styles.tableBody}>
                        <tr />
                        {list.length > 0 ? (
                            list.map((item) => (
                                <DataRow
                                    setKeyword={setKeyword}
                                    keyword={keyword}
                                    item={item}
                                    isDeleting={isDeleting}
                                    list={list}
                                    setIsDeleting={setIsDeleting}
                                />
                            ))
                        ) : (
                            <p>No Key terms Found.</p>
                        )}
                    </tbody>
                </table>
            </div>
            {!editor && keyword && (
                <ModalComponent
                    keyWord={keyword.keyword}
                    keyWordVariation={keyword.keyword_variations}
                    report_info={reportInfo}
                />
            )}
        </div>
    );
};

export default NlpTopics;
